export const initOpeningHours = () => {
    const callButton = document.getElementsByClassName('header__top-menu__phone')[0];
    const openingHours = document.getElementsByClassName('opening-hours')[0];
    const openingHoursLink = document.getElementsByClassName('opening-hours__link')[0];
    const telLink = document.getElementsByClassName('header__top-menu__link --phone --hidden')[0];

    const LANDSCAPE_TABLET_WIDTH = 960;
    callButton.addEventListener('click', () => {
        if (window.innerWidth >= LANDSCAPE_TABLET_WIDTH) {
            return;
        }
        openingHours.classList.toggle('--visible');
    });

    callButton.addEventListener('mouseenter', () => {
        if (window.innerWidth <= LANDSCAPE_TABLET_WIDTH) {
            return;
        }
        openingHours.classList.add('--visible');
    });
    callButton.addEventListener('mouseleave', () => {
        if (window.innerWidth <= LANDSCAPE_TABLET_WIDTH) {
            return;
        }
        openingHours.classList.remove('--visible');
    });

    openingHoursLink.addEventListener('click', () => {
        const eventObject = document.createEvent('Events');
        eventObject.initEvent('click', true, false);
        telLink.dispatchEvent(eventObject);
    });
};
export default initOpeningHours;
